// OUR PARTNERS: WHY JGYU STICKY LEFT ON WEB

(function () {
  var header = document.querySelector('.header-wrapper') || document.querySelector('header');
  if (!header) return;

  function updateStickyTop() {
    if (window.innerWidth < 750) {
      document.documentElement.style.removeProperty('--sticky-top');
      return;
    }
    var headerVisible = header.getBoundingClientRect().bottom > 0;
    var headerHeight = headerVisible ? header.offsetHeight : 0;
    var offset = 24; // extra space in px
    document.documentElement.style.setProperty('--sticky-top', (headerHeight + offset) + 'px');
  }

  // Run on scroll
  window.addEventListener('scroll', updateStickyTop, { passive: true });

  // Run on resize in case header height changes at breakpoints
  window.addEventListener('resize', updateStickyTop, { passive: true });

  // Run once on init
  updateStickyTop();
})();

// OUR PARTNERS: WHY JGYU CARD ON MOBILE

(function () {
  function initWhyJgyuDots() {
    if (window.innerWidth >= 750) return;
 
    var section = document.querySelector('#shopify-section-template--21551984574602__section_tRfVGC');
    if (!section) return;
 
    var track = section.querySelector('.section-content-wrapper > .group-block:last-child > .group-block-content');
    if (!track) return;
 
    var cards = Array.from(track.querySelectorAll(':scope > .group-block'));
    if (cards.length < 2) return;
 
    // Build dots
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'why-jgyu-dots';
 
    var dots = cards.map(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'why-jgyu-dot';
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
      dot.addEventListener('click', function () {
        var card = cards[i];
        var targetScroll = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
        track.scrollTo({ left: targetScroll, behavior: 'smooth' });
        setActiveDot(i);
      });
      dotsWrap.appendChild(dot);
      return dot;
    });
 
    // Append dots as sibling AFTER the group-block-content, inside the right column's group-block
    track.insertAdjacentElement('afterend', dotsWrap);
 
    function setActiveDot(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }
 
    function getClosestCardIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closestIndex = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(cardCenter - trackCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });
      return closestIndex;
    }
 
    var rafId = null;
    track.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        setActiveDot(getClosestCardIndex());
        rafId = null;
      });
    }, { passive: true });
 
    setActiveDot(0);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhyJgyuDots);
  } else {
    initWhyJgyuDots();
  }
})();

